import { defineComponent as o, openBlock as r, createBlock as a, normalizeProps as n, guardReactiveProps as p, withCtx as s, renderSlot as c, createElementVNode as l } from "vue";
import d from "../CdrIcon.vue.mjs";
const m = /* @__PURE__ */ l("path", {
  role: "presentation",
  d: "M20.707 19.294a1 1 0 01-1.414 1.414l-4.244-4.245a7.5 7.5 0 111.414-1.414l4.244 4.245zM10.5 16a5.5 5.5 0 100-11 5.5 5.5 0 000 11z"
}, null, -1), f = /* @__PURE__ */ o({
  name: "Search",
  __name: "search",
  props: {
    props: {
      type: Object
    }
  },
  setup(e) {
    return (t, i) => (r(), a(d, n(p(e.props)), {
      default: s(() => [c(t.$slots, "default"), m]),
      _: 3
    }, 16));
  }
});
export {
  f as default
};
